import React from 'react';

function Footer() {
  return (
    <footer className="slds-p-around_x-large slds-background_default" style={{ backgroundColor: '#0070d2', color: 'white', marginTop: '4rem' }}>
      <div className="slds-grid slds-gutters slds-wrap">
        <div className="slds-col slds-size_1-of-1 slds-medium-size_1-of-3 slds-p-bottom_medium slds-medium-p-bottom_none">
          <h3 className="slds-text-heading_small slds-p-bottom_small" style={{ color: 'white' }}>Contact</h3>
          <p className="slds-text-body_regular" style={{ color: 'white' }}>
            Email:<br />
            <a href="mailto:EricaLayer@peakautismcenter.com" style={{ color: 'white' }}>EricaLayer@peakautismcenter.com</a><br />
            <a href="mailto:DrewFry@peakautismcenter.com" style={{ color: 'white' }}>DrewFry@peakautismcenter.com</a><br />
            <br />
            Phone: (810) 937-5012<br />
            Fax: (844) 205-9989
          </p>
        </div>
        
        <div className="slds-col slds-size_1-of-1 slds-medium-size_1-of-3 slds-p-bottom_medium slds-medium-p-bottom_none">
          <h3 className="slds-text-heading_small slds-p-bottom_small" style={{ color: 'white' }}>Locations</h3>
          <p className="slds-text-body_regular" style={{ color: 'white' }}>
            18101 E. Warren Avenue<br />
            Detroit, MI 48224<br />
            <br />
            3071 Commerce Drive<br />
            Fort Gratiot, MI 48059
          </p>
        </div>
        
        <div className="slds-col slds-size_1-of-1 slds-medium-size_1-of-3">
          <h3 className="slds-text-heading_small slds-p-bottom_small" style={{ color: 'white' }}>Hours of Operation</h3>
          <p className="slds-text-body_regular" style={{ color: 'white' }}>
            Monday - Friday: 8:00 AM - 6:30 PM<br />
            Saturday: Closed<br />
            Sunday: Closed
          </p>
        </div>
      </div>
      
      <div className="slds-grid slds-gutters slds-p-top_medium slds-border_top" style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}>
        <div className="slds-col slds-size_1-of-1 slds-text-align_center">
          <p className="slds-text-body_small" style={{ color: 'white' }}>
            © {new Date().getFullYear()} Peak Autism Center. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 